function isUncodedTraceStatus(status) {
  return status === 'unarchived' || status === null || status === undefined || status === ''
}

function isBatchCodingSelectable(record) {
  return !!record && record.types === 'product' && isUncodedTraceStatus(record.trace_status)
}

function getBatchCodingActionState(selectedCount) {
  if (!selectedCount) {
    return { disabled: true, text: '请先选择商品', message: '请先选择要赋码的商品' }
  }
  return { disabled: false, text: '为选中商品赋码', message: '' }
}

function toNonNegativeInteger(value) {
  const number = Number(value) || 0
  return number > 0 ? Math.floor(number) : 0
}

function normalizeCodingStats(raw) {
  const source = raw || {}
  const total = toNonNegativeInteger(source.total)
  const coded = Math.min(toNonNegativeInteger(source.coded), total)
  const complete = Math.min(toNonNegativeInteger(source.complete), coded)
  const pending = Math.min(toNonNegativeInteger(source.pending), coded - complete)
  const uncoded = Math.max(total - coded, 0)
  const codedRate = total > 0 ? Math.min(100, Math.round((coded / total) * 100)) : 0

  return {
    total,
    coded,
    uncoded,
    pending,
    complete,
    codedRate,
  }
}

module.exports = {
  getBatchCodingActionState,
  isBatchCodingSelectable,
  isUncodedTraceStatus,
  normalizeCodingStats,
}
